﻿import swal, { type SweetAlertResult } from 'sweetalert2';

const swalBase = swal.mixin({
    didOpen: (popup) => {
        if (popup.parentElement) {
            popup.parentElement.style.zIndex = '200000';
        }
    }
});

function deletePopup(
    afterConfirmFunc?: () => void,
    afterCancelFunc?: () => void,
    confirmText?: string
) {
    const dict = window.getLocaleDict().toastr;

    if (!confirmText) {
        confirmText = dict.deleteConfirmText;
    }

    swalBase.fire({
        title: dict.deleteTitle,
        text: confirmText,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: dict.deleteButton,
        cancelButtonText: dict.cancelButton,
        focusCancel: true
    })
        .then((result: SweetAlertResult) => {
            result.value ? afterConfirmFunc?.() : afterCancelFunc?.();
        });
}

function standartErrorAnswer() {
    const dict = window.getLocaleDict().toastr;

    swalBase.fire(
        dict.errorTitle,
        dict.serverErrorText,
        'warning'
    );
}

window.swal = swalBase;
window.standartErrorAnswer = standartErrorAnswer;
window.deletePopup = deletePopup;
